import { render } from "./CompanyCategories.vue?vue&type=template&id=6c8e05af"
import script from "./CompanyCategories.vue?vue&type=script&lang=js"
export * from "./CompanyCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__